import { Tag } from '@factorialco/deprecated-design-system'
import { TimeSettingsEnumsTimeTypeEnum } from 'generated/resources/graphql'

// If the category name is too long, it should be displayed with an ellipsis, however, the time type should always be shown in full.
// e.g. Veryveryveryverylongna... ･ Regular
// The selector label is a simple string, so I cannot apply this logic there. Instead, I'm limiting the length of the text.
export const categoryTimeTypeTag = (timeType: TimeSettingsEnumsTimeTypeEnum) => {
  switch (timeType) {
    case 'overtime':
      return Tag.Types.tangerine
    case 'regular':
      return Tag.Types.grey
    case 'any_time':
      return Tag.Types.purple
    default:
      const exhaustiveCheck: never = timeType
      throw new Error(`Unhandled timeType: ${exhaustiveCheck}`)
  }
}
